import { useFormikContext } from "formik"
import { get } from "lodash"
import React from "react"
import ReactPhoneInput, { CountryData, PhoneInputProps } from "react-phone-input-2"

import "react-phone-input-2/lib/style.css"
import styles from "./PhoneInput.module.css"

interface MonoPhoneInputProps extends PhoneInputProps {
  name: string
  onChange?: (value: string, country: Record<string, never> | CountryData) => void
  variant?: "rounded" | "solid"
  className?: string
  dialCodeName: string
  testid?: string
}

const PhoneInput = ({
  name,
  dialCodeName,
  onChange,
  variant = "rounded",
  testid,
  ...rest
}: MonoPhoneInputProps) => {
  const { errors, touched, setFieldValue, values } = useFormikContext()
  const error = get(errors, name)
  const fieldTouched = get(touched, name)
  const value = get(values, name)
  const dialCode = get(values, dialCodeName)

  return (
    <ReactPhoneInput
      value={`${dialCode}${value}`}
      {...rest}
      data-testid={testid}
      inputProps={{
        name,
        required: true,
        autoFocus: false,
        autoComplete: `${dialCode}${value}-phone-input-${Math.random()}`,
        "data-testid": "phone",
      }}
      countryCodeEditable={false}
      disableCountryCode={false}
      inputStyle={{
        width: "inherit",
        height: "inherit",
        borderRadius: 6,
        paddingRight: 7,
        paddingTop: 7,
        paddingBottom: 7,
        borderColor: error && fieldTouched ? "#DC3838" : "#E7E7E8",
      }}
      buttonStyle={{
        backgroundColor: "transparent",
        borderRadius: "6px 0 0 6px",
        borderRight: "none",
        borderColor: error && fieldTouched ? "#DC3838" : "#E7E7E8",
      }}
      country={"us"}
      enableSearch
      searchPlaceholder={"Enter Phone Number"}
      onChange={(value, country) => {
        setFieldValue(name, value.slice((country as unknown as CountryData).dialCode.length))
        onChange?.(value, country)
      }}
      inputClass={
        variant === "solid"
          ? "!rounded-none !rounded-t-md !border-x-0 !border-t-0 !bg-neutral-50 !text-neutral-1000 hover:!border-primary-500 active:!border-primary-600 focus:!border-primary-600 focus:!ring-0"
          : ""
      }
      buttonClass={
        variant === "solid" ? "!rounded-none !rounded-t-md	 !border-0 !text-neutral-1000" : ""
      }
      containerClass={styles.phoneInputstyle}
    />
  )
}

export default PhoneInput
